<div [ngClass]="typeClass">
</div>